import React from 'react'
import Jumbotron from '../components/Jumbotron';
import styled from 'styled-components';

let ImageS = './images/about-us-320.jpg';
let ImageM = './images/about-us-640.jpg';
let ImageL = './images/about-us-1024.jpg';

const AboutUs = styled.div`

    .row:first-child {
        @media(max-width: 500px) {
            flex-direction: column-reverse
        }

        div:nth-child(2) {
            @media(max-width: 500px) {
                padding-bottom: 25px;
            }
        }
    }
`;
const AboutImg = styled.img`
  max-width: 100%;
`

export default () => (
    <div>
        <Jumbotron title='About Us' subtext='Info about the company'/>
        <AboutUs className="p-5">
            <div className="row">
                <div className="col-12 col-sm-6 mb-5">
                  <h3>Calmel Drafting & Designs<small className="text-muted"> - Who we are</small></h3>
                      <p className="lead">CalMel Designs is an integrated design firm that works with a team of architects, engineers,
                      contractors (Builders), and property owners to help better the development of its clients. CalMel has
                      been serving Southern California since 2009, providing service for residential/high-end, commercial,
                      industrial, &amp; food services. Our knowledge in advance programing provides us with a descriptive
                      design in our remodeling and expansion projects. Our expertise services have provided us with
                      regular clients and new business obtained through client referrals, which goes to show the excellent
                      services we provide.</p>
                </div>
                <div className="col-12 col-sm-6">
                  <AboutImg alt='about us photo, collaboration' srcSet={
                      `${ImageS} 320w,
                      ${ImageM} 640w,
                      ${ImageL} 1024w`} sizes={"(max-width: 420px) 320px, (max-width: 740px) 640px, (max-width: 1124px) 1024px, 1024px"} />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <h3>Company Promise<small className="text-muted"> - Our goal</small></h3>
                        <p className="lead">Our main goal for drafting &amp; design services consists of providing as-built documentation for
                        existing and new property, and assuring accuracy and acceptance by the Los Angeles California
                        Planning and Building Agencies, as well as our variety of clients. We take field measurements for
                        residential houses, apartments, and commercial buildings. We present quick and accurate measuring
                        services. We measure buildings of any kind with a high level of accuracy very close tolerance levels.</p>
                        <br/>
                        <p className="lead">As a pioneer and innovator in this growing industry, CalMel has earned a reputation in providing
                        good fast quality work. Its relationship with consultants, contractors, and property owners has grown
                        through the years. No project is too small for us.</p>
                </div>
            </div>
        </AboutUs>
    </div>
);


// WEBPACK FOOTER //
// ./src/views/About.js